module.exports = __webpack_public_path__ + "img/labels-3-d-mobile.1d9b51a7.webp";